import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subject, Observable } from 'rxjs';

export class Notification {

  constructor(
    public id: number,
    public type: NotificationType,
    public title: string,
    public message: string,
    public timeout: number,
  ) { }

}

export enum NotificationType {
  success = 0,
  warning = 1,
  error = 2,
  info = 3
}

@Injectable()
export class NotificationService {

  private _subject = new Subject<Notification[]>();
  private _idx = 0;

  notifications: Notification[] = [];

  get notificationsChanged(): Observable<Notification[]> {
    return this._subject.asObservable();
  }

  constructor(
    router: Router) {
    router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        // When navigation starts remove notification without timeout
        this.notifications = this.notifications.filter(n => !!n.timeout);
        this._subject.next(this.notifications);
      }
    });
  }

  info(message: string, title: string = null, timeout = 5000) {
    const notification = new Notification(this._idx++, NotificationType.info, title, message, timeout);
    this._addNotification(notification);
  }

  success(message: string, title: string = null, timeout = 5000) {
    const notification = new Notification(this._idx++, NotificationType.success, title, message, timeout);
    this._addNotification(notification);
  }

  warning(message: string, title: string = null, timeout = 0) {
    const notification = new Notification(this._idx++, NotificationType.warning, title, message, timeout);
    this._addNotification(notification);
  }

  error(message: string, title: string = null, timeout = 0) {
    const notification = new Notification(this._idx++, NotificationType.error, title, message, timeout);
    this._addNotification(notification);
  }

  close(notification: Notification) {
    this.notifications = this.notifications.filter(n => n.id !== notification.id);
    this._subject.next(this.notifications);
  }

  private _addNotification(notification: Notification) {
    if (!this.notifications.some(m => m.message === notification.message && m.title === notification.title)) {
      this.notifications.push(notification);
      if (notification.timeout !== 0) {
        setTimeout(() => this.close(notification), notification.timeout);
      }
      this._subject.next(this.notifications);
    }
  }
}
